var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f7931e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.9,891.3H104.7c-9.2,0-16.6-7.4-16.6-16.6v-75.1c0-9.2,7.4-16.6,16.6-16.6h38.4c9.1,0,16.6,7.4,16.6,16.6s-7.4,16.6-16.6,16.6h-21.8v41.9h165.6c9.2,0,16.6,7.4,16.6,16.6s-7.4,16.6-16.6,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1166.6,891.3H496.4c-9.2,0-16.6-7.4-16.6-16.6s7.4-16.6,16.6-16.6h653.7v-41.9h-634.8c-9.2,0-16.6-7.4-16.6-16.6s7.4-16.6,16.6-16.6h651.4c9.2,0,16.6,7.4,16.6,16.6v75.1c0,9.2-7.4,16.6-16.6,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.6,816.2h-126.5c-9.2,0-16.6-7.4-16.6-16.6s7.4-16.6,16.6-16.6h126.5c9.2,0,16.6,7.4,16.6,16.6,0,9.2-7.4,16.6-16.6,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1128.2,816.2c-9.2,0-16.6-7.4-16.6-16.6V198.5c0-9.2,7.4-16.6,16.6-16.6s16.6,7.4,16.6,16.6v601.1c0,9.2-7.4,16.6-16.6,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.1,816.2c-9.2,0-16.6-7.4-16.6-16.6V198.5c0-9.2,7.4-16.6,16.6-16.6s16.6,7.4,16.6,16.6v601.1c0,9.2-7.4,16.6-16.6,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1166.6,215.1H104.7c-9.2,0-16.6-7.4-16.6-16.6v-75.1c0-9.2,7.4-16.6,16.6-16.6h1061.9c9.2,0,16.6,7.4,16.6,16.6v75.1c0,9.2-7.4,16.6-16.6,16.6ZM121.3,181.9h1028.7v-41.9H121.3v41.9Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.1,653.8c-45.9,0-83.3-41.5-83.3-92.5s37.4-92.5,83.3-92.5,83.3,41.5,83.3,92.5c0,51-37.4,92.5-83.3,92.5ZM396.1,502c-27.6,0-50.1,26.6-50.1,59.3s22.5,59.3,50.1,59.3,50.1-26.6,50.1-59.3-22.5-59.3-50.1-59.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.2,1165.7h-158.1c-9.2,0-16.6-7.4-16.6-16.6v-242.1l-35.1-37.5c-2.9-3.1-4.5-7.1-4.5-11.3v-178.1c0-7.5,5-14.1,12.3-16l39.5-10.6c9-2.3,18,2.9,20.3,11.7,2.4,8.9-2.9,18-11.8,20.3l-27.2,7.3v158.8l35.1,37.5c2.9,3.1,4.5,7.1,4.5,11.3v232.1h124.9v-232.1c0-3.9,1.3-7.6,3.8-10.6l36.3-44v-91.2c0-9.2,7.4-16.6,16.6-16.6s16.6,7.4,16.6,16.6v97.2c0,3.9-1.3,7.6-3.8,10.5l-36.3,44v242.7c0,9.2-7.4,16.6-16.6,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.7,696.6c-1.4,0-2.9-.2-4.3-.6l-39.5-10.6c-8.9-2.4-14.1-11.5-11.8-20.3,2.4-8.8,11.5-14,20.3-11.7l31.8,8.5,197.3-145.5c7.4-5.4,17.8-3.8,23.2,3.5,5.4,7.4,3.9,17.8-3.5,23.2l-203.7,150.3c-2.9,2.1-6.4,3.2-9.9,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.1,1165.7c-9.2,0-16.6-7.4-16.6-16.6v-203.7c0-9.2,7.4-16.6,16.6-16.6s16.6,7.4,16.6,16.6v203.7c0,9.2-7.4,16.6-16.6,16.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidanceIcon);
export default __webpack_public_path__ + "static/media/guidance-icon.a7d92f77eb867c16f84ece7db2f72cc2.svg";
export { ForwardRef as ReactComponent };